import {useEffect, useState, useRef} from 'react';

// New ResponsiveIframe component
export default function ResponsiveIframe({src, allow, allowFullScreen}) {
  const iframeRef = useRef(null);
  const [iframeHeight, setIframeHeight] = useState('315'); // Initial height

  useEffect(() => {
    function handleResize() {
      if (iframeRef.current) {
        const width = iframeRef.current.offsetWidth;
        // Set the height dynamically while maintaining 16:9 aspect ratio
        setIframeHeight((9 / 16) * width);
      }
    }

    // Attach the event listener
    window.addEventListener('resize', handleResize);

    // Call it once to set the initial height
    handleResize();

    // Clean up the event listener when the component is unmounted
    return () => {
      window.removeEventListener('resize', handleResize);
    }
  }, []);

  return (
    <div>
      <iframe
        ref={iframeRef}
        width="100%"
        height={`${iframeHeight}px`}
        src={src}
        allow={allow}
        allowFullScreen={allowFullScreen}
      />
    </div>
  );
}

